/*
 * Header scroll state — menkind-style overlay header.
 *
 * The overlay header (homepage + About) starts transparent over the hero with a light logo. Once the
 * page scrolls past a small threshold, `.is-scrolled` is toggled on it; CSS then slides a cream
 * background down, darkens the text/border, and cross-fades the light logo to the dark one. Returning
 * to the top removes the class and transitions it back.
 *
 * Discrete state toggle (not scrubbed) — matches the eased on/off feel. A plain ScrollTrigger is used,
 * so it works whether Lenis drives the scroll or it's native (theme editor / reduced motion). Unlike
 * the decorative scroll scripts this does NOT early-return under reduced motion: the state change is
 * functional (legibility of light text over a cream section), so it must still fire; the CSS drops the
 * transitions under prefers-reduced-motion so it switches instantly.
 */
(function () {
  // ScrollTrigger is registered in smooth-scroll.js (loaded just before this file).
  if (!window.gsap || !window.ScrollTrigger) return;

  const init = () => {
    const header = document.querySelector('[data-header]');
    // Only the transparent overlay header has a scrolled state; solid headers stay as-is.
    if (!header || !header.classList.contains('wp-header--overlay')) return;

    ScrollTrigger.create({
      start: 80, // px scrolled from the top before the cream state kicks in
      end: 'max',
      onToggle: (self) => header.classList.toggle('is-scrolled', self.isActive),
    });
  };

  // A fixed 80px start doesn't depend on layout, so no need to wait for fonts; smooth-scroll.js does
  // the page's one post-font ScrollTrigger.refresh().
  init();
})();
